import styled from 'styled-components';

export const ModalLayout = styled.div`
  background-color: rgba(0, 0, 0, 0.3);
  z-index: ${({ zIndex }) => zIndex};
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: auto;
  ${({ isEvents, isSlider }) => !isEvents && 'padding: 60px 0'}
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  //transition: 0.4s;
  opacity: ${({ active }) => (active ? 1 : 0)};
  visibility: ${({ active }) => (active ? 'visible' : 'hidden')};
  > div {
    //transition: opacity 10s linear;
    // transform: translateY(${({ active }) => (active ? '0' : '-100vh')});
  }
  @media (max-width: 610px) {
    padding: ${({fullOverlay}) => fullOverlay ? '0px' : '10vw 0'};
  }
`;

export const SliderLayout = styled.div`
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 20;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: right;
  pointer-events: auto;
  transition: 0.4s;
  opacity: ${({ active }) => (active ? 1 : 0)};
  visibility: ${({ active }) => (active ? 'visible' : 'hidden')};
  > div {
    transition: 0.4s;
    transform: translateX(${({ active }) => (active ? '0' : '100vw')});
  }
`;

export const Modal = styled.div`
  background-color: white;
  max-width: ${(props) => `${props.width}px`};
  width: 100%;
  margin: auto;
  border-radius: 24px;
  position: relative;
  ${({ height }) => (height ? `height: ${height}` : '')};
`;
export const ModalTitle = styled.h2`
  margin: 0;
  padding: 48px 32px 0 32px;
  font-weight: 800;
  font-size: 28px;
  line-height: 34px;
  display: flex;
  align-items: center;
  color: #222224 !important;
  @media (max-width: 800px) {
    font-size: 24px;
    line-height: 110%;
    padding: 30px 20px 0 20px;
  }
  @media (max-width: 610px) {
    padding: 5vw 5vw 0 5vw;
    font-size: 6.5vw;
    line-height: 8vw;
    width: 90%;
  }
`;
export const ModalContent = styled.div`
  ${({ content_padding }) =>
    content_padding ? `padding: ${content_padding};` : 'padding: 48px 32px;'}
  @media (max-width: 800px) {
    padding: 20px;
  }
  @media (max-width: 610px) {
    padding: ${({fullOverlay}) => fullOverlay ? '0px' : '5vw'};
    ${({fullOverlay}) => fullOverlay && 'height: 100vh;'}
  }
  ${({ fixedHeight }) => fixedHeight && `height: ${fixedHeight}`}
`;

export const ModalPrevButton = styled.button`
  background-color: #fafafa;
  z-index: 1000;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  top: 20px;
  left: 20px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    height: 17px;
    width: 17px;
    fill: #222224;
  }
  @media (max-width: 610px) {
    width: 6.5vw;
    height: 6.5vw;
    top: 5vw;
    left: 5vw;
    font-size: 100%;
  }
`;

export const ModalCloseButton = styled.button`
  color: #222224;
  font-size: 25px;
  font-weight: bold;

  background-color: #fafafa;
  z-index: 1000;
  border-radius: 50%;
  width: 36px;
  height: 36px;

  top: 20px;
  right: 20px;
  position: absolute;
  @media (max-width: 610px) {
    width: 6.5vw;
    height: 6.5vw;
    top: 5vw;
    right: 5vw;
    font-size: 100%;
  }
`;

export const PreviewCloseButton = styled.button`
  color: #222224;
  background-color: #fafafa;
  z-index: 1000;
  border-radius: 100px;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: center;
  top: 27px;
  right: 20px;
  position: absolute;
  padding: 9px 16px;
  svg {
    margin-left: 6px;
  }
  @media (max-width: 610px) {
    width: 6.5vw;
    height: 6.5vw;
    top: 5vw;
    right: 5vw;
    font-size: 100%;
  }
`;

export const ModalBackButton = styled.button`
  background-color: #fafafa;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  outline: none;
  cursor: pointer;
  margin-right: 16px;
  @media (max-width: 610px) {
    width: 6.5vw;
    height: 6.5vw;
    margin-right: 5vw;
  }
`;

export const PreviewLabel = styled.div`
  padding: 2px 6px;
  background: #fff5e7;
  border-radius: 100px;
  font-weight: 600;
  font-size: 10px;
  line-height: 12px;
  display: flex;
  align-items: center;
  color: #995c00;
  position: absolute;
  top: 35px;
  left: 24px;
`;
